/** The rep's choice for the quantity a document can't fill, applied at submit and never stored (NUDOOL-113). */
export var ShortfallAction;
(function (ShortfallAction) {
    ShortfallAction["REMOVE"] = "REMOVE";
    ShortfallAction["BACKORDER"] = "BACKORDER";
    ShortfallAction["KEEP"] = "KEEP";
})(ShortfallAction || (ShortfallAction = {}));
//# sourceMappingURL=shortfall-action.js.map